import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Loader, ValidationService, UnsubscriberClass, ObjectPropertyNamesHolder, ValidationServiceHelper, extractFormControlNames, FormControlFeedbackComponent } from '@aston/foundation';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil, tap } from 'rxjs/operators';
import { ConsoleDomainValidators } from 'apps/console/src/app/shared-module/enums/validators';
import { Store } from '@ngrx/store';
import { DisplayEmailAlreadyExistInGuestListError, DisplayEmailAlreadyExistInUserListError } from 'apps/console/src/app/root-store/federation-detail-store/actions';
import { ICreateRegistrationUserFederationValidator } from 'apps/console/src/app/shared-module/enums/validators/create-federation-user-form.validators';
import { TranslateModule } from '@ngx-translate/core';

import { ICreateRegistrationUserFederationForm, IFederationUser } from '../../models';


export const formControlNames = (name: keyof ICreateRegistrationUserFederationForm) => name;

export type FormValidatorFieldsType = ICreateRegistrationUserFederationValidator['fields'];

@Component({
	selector: 'federation-user-create-form',
	templateUrl: './federation-user-create-form.component.html',
	imports: [ReactiveFormsModule, TranslateModule, FormControlFeedbackComponent,]
})

export class FederationUserCreateFormComponent extends UnsubscriberClass implements OnInit {
	activeModal = inject(NgbActiveModal);
	protected formBuilder = inject(UntypedFormBuilder);
	private validationService = inject(ValidationService);
	private store = inject(Store);

	@Output() cancelForm = new EventEmitter<boolean>();
	@Output() submitForm = new EventEmitter<any>();
	@Input() usersList: IFederationUser[];

	form: UntypedFormGroup;
	formControlNames: ObjectPropertyNamesHolder<ICreateRegistrationUserFederationForm>;
	validationHelper: ValidationServiceHelper;
	rulesetFields: FormValidatorFieldsType;

	formLoader = Loader.empty();
	guestsList = new FormArray<UntypedFormGroup>([]);

	ngOnInit() {
		this.form = this.formBuilder.group({});
		this.form.addControl('addUserName', new UntypedFormControl());

		this.formControlNames = extractFormControlNames<ICreateRegistrationUserFederationForm>(this.form);

		this.validationService.getHelper(ConsoleDomainValidators.CreateRegistrationUserFederationValidator)
			.pipe(tap(([helper, fields]) => {
				this.validationHelper = helper;
				this.rulesetFields = fields as FormValidatorFieldsType;
				this.setFormValidators();
			}))
			.pipe(takeUntil(this.destroySubscriptions$))
			.subscribe();
	}

	setFormValidators() {
		this.validationHelper.control(this.addUserNameField, this.rulesetFields.UserName);
	}

	get addUserNameField() {
		return this.form.get('addUserName');
	}

	addToGuestsList() {
		const guestEmail = '' + this.addUserNameField.value;
		const group = new UntypedFormGroup({
			userName: new FormControl<string>(guestEmail),
		});
		group.get('userName').disable();
		if (this.alreadyExist(guestEmail)) {
			this.store.dispatch(DisplayEmailAlreadyExistInUserListError())
		} else if (this.alreadyExistInGuestList(guestEmail)) {
			this.store.dispatch(DisplayEmailAlreadyExistInGuestListError())
		} else {
			this.guestsList.push(group);
		}
		this.form.reset();
	}

	alreadyExist(guestEmail) {
		return this.usersList.some(element => element.userName === guestEmail);
	}

	alreadyExistInGuestList(guestEmail) {
		return this.guestsList.value.some(element => element.userName === guestEmail);
	}

	removeInvite(index: number) {
		this.guestsList.removeAt(index);
	}

	onSubmit() {
		this.submitForm.emit(this.guestsList.value);
		this.activeModal.dismiss()
	}
}
